module.exports = __webpack_public_path__ + "static/media/parker-ellington-davis.85eb25aa.jpg";